var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21.3884 19.0137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.388428,
    height: 19.013672,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4 4125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9917",
    d: "M3.66971 8.34805C1.5639 8.87091 0.004776 10.7604 1.52588e-05 13.0064C-0.00473022 15.6197 2.19139 17.8086 4.82954 17.8253C6.91241 17.8429 8.77438 16.5299 9.45706 14.562C9.61923 14.0879 9.37416 13.5709 8.90446 13.3962C6.91649 12.6581 5.39482 11.0231 4.80103 8.98737C4.65875 8.50342 4.1579 8.21982 3.66971 8.34683L3.66971 8.34805Z",
    opacity: 0.999144971,
    fill: "rgb(166,179,202)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9917",
    d: "M1.52588e-05 13.0064C-0.00473022 15.6197 2.19139 17.8086 4.82954 17.8253C6.91241 17.8429 8.77438 16.5299 9.45706 14.562C9.61923 14.0879 9.37416 13.5709 8.90446 13.3962C6.91649 12.6581 5.39482 11.0231 4.80103 8.98737C4.65875 8.50342 4.1579 8.21982 3.66971 8.34683L3.66971 8.34805C1.5639 8.87091 0.004776 10.7604 1.52588e-05 13.0064Z",
    opacity: 0.999144971,
    fillRule: "nonzero",
    stroke: "rgb(112,112,112)",
    strokeOpacity: 0,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4 4128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9916",
    d: "M5.93945 7.12999C5.93945 10.4116 8.59967 13.0718 11.8813 13.0718C15.1628 13.0718 17.8232 10.4116 17.8232 7.12999C17.8232 3.84839 15.1628 1.18811 11.8813 1.18811C8.59967 1.18811 5.93945 3.84839 5.93945 7.12999Z",
    fill: "rgb(120,138,173)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9916",
    d: "M11.8813 13.0718C15.1628 13.0718 17.8232 10.4116 17.8232 7.12999C17.8232 3.84839 15.1628 1.18811 11.8813 1.18811C8.59967 1.18811 5.93945 3.84839 5.93945 7.12999C5.93945 10.4116 8.59967 13.0718 11.8813 13.0718Z",
    fillRule: "nonzero",
    stroke: "rgb(112,112,112)",
    strokeOpacity: 0,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9918",
    d: "M1.18579 2.07928C1.18633 2.82207 1.58275 3.50822 2.22595 3.8797C2.86916 4.25116 3.66162 4.25162 4.30524 3.88084C5.17921 3.37628 5.56477 2.31708 5.21973 1.36873C4.87463 0.420395 3.89851 -0.143341 2.90466 0.031723C1.91077 0.206802 1.18602 1.07013 1.18579 2.07928ZM17.855 11.8833C16.8987 11.8757 15.9792 12.2522 15.303 12.9285C14.6267 13.6047 14.2502 14.5242 14.2578 15.4805C14.2759 17.4242 15.8472 18.9955 17.7908 19.0136C18.7472 19.0212 19.6667 18.6447 20.3429 17.9684C21.0192 17.2922 21.3957 16.3727 21.3881 15.4164C21.3687 13.4732 19.7982 11.9027 17.855 11.8833L17.855 11.8833Z",
    fill: "rgb(120,138,173)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9918",
    d: "M2.22595 3.8797C2.86916 4.25116 3.66162 4.25162 4.30524 3.88084C5.17921 3.37628 5.56477 2.31708 5.21973 1.36873C4.87463 0.420395 3.89851 -0.143341 2.90466 0.031723C1.91077 0.206802 1.18602 1.07013 1.18579 2.07928C1.18633 2.82207 1.58275 3.50822 2.22595 3.8797ZM15.303 12.9285C14.6267 13.6047 14.2502 14.5242 14.2578 15.4805C14.2759 17.4242 15.8472 18.9955 17.7908 19.0136C18.7472 19.0212 19.6667 18.6447 20.3429 17.9684C21.0192 17.2922 21.3957 16.3727 21.3881 15.4164C21.3687 13.4732 19.7982 11.9027 17.855 11.8833L17.855 11.8833C16.8987 11.8757 15.9792 12.2522 15.303 12.9285Z",
    fillRule: "nonzero",
    stroke: "rgb(112,112,112)",
    strokeOpacity: 0,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFx);
export default __webpack_public_path__ + "static/media/fx.4f6099b88ce3cc0428007855b8d371fd.svg";
export { ForwardRef as ReactComponent };